import React, { useState } from 'react';
import { sanitizeHtml } from '../../../Utils/sanitize';
import styles from './SearchResultItem.module.scss';

const SearchResultItem = ({ result, onResultClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 150;

  const contentTypeIconMap = {
    'Guides': 'book',
    'Workflows': 'hub',
    'APIReference': 'code',
    'Changelog': 'history',
    'Default': 'article'
  };

  const needsTruncation = result.preview.length > maxLength;

  const handleMoreClick = (e) => {
    e.stopPropagation();
    setIsExpanded(true);
  };

  const iconName = contentTypeIconMap[result.contentType] || contentTypeIconMap['Default'];

  return (
    <div className={styles.searchResultItem} onMouseDown={() => onResultClick(result)}>
      <div className={styles.resultHeader}>
        <i className={`material-icons ${styles.resultIcon}`}>{iconName}</i>
        <div className={styles.resultTitle}>{result.title}</div>
      </div>
      <div className={styles.resultPreview}>
        {isExpanded ? (
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(result.preview) }} />
        ) : (
          <>
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(needsTruncation ? `${result.preview.substring(0, maxLength)}...` : result.preview) }} />
            {needsTruncation && (
              <div className={styles.moreButtonContainer}>
                <button onClick={handleMoreClick} className={styles.moreButton}>
                  more
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SearchResultItem;